import CommonIFrame from '../atoms/CommonIFrame';

const PLComparison = () => {
    return <CommonIFrame src="https://dssdgfdgty.lovable.app" title="P&LComparison" />;
};

export default PLComparison;
